/* jshint esnext: true */
/**
 * dropdown menu
 ***********************/
$(() => {
  $('.js-dropdownMenu__item').hover(ev => {
    // mouseenter
    var
      $this = $(ev.currentTarget),
      dataType = $this.data('type');

    $this.addClass('js-active');

    $('.js-dropdownMenu__panel').each((idx, el) => {
      var $el = $(el);

      if ($el.data('type') !== dataType) return;

      $el.css({
        display: 'block'
      });
    });
  }, ev => {
    // mouseleave
    var
      $this = $(ev.currentTarget),
      dataType = $this.data('type');

    $this.removeClass('js-active');

    $('.js-dropdownMenu__panel').each((idx, el) => {
      var $el = $(el);

      if ($el.data('type') !== dataType) return;

      $el.css({
        display: ''
      });
    });
  }); // $('.js-dropdownMenu__item').hover()

  $('.js-dropdownMenu__panel').hover(ev => {
    // mouseenter
    var
      $this = $(ev.currentTarget),
      dataType = $this.data('type');

    $this.css({display: 'block'});

    $('.js-dropdownMenu__item').each((idx, el) => {
      var $el = $(el);

      if ($el.data('type') !== dataType) return;

      $el.addClass('js-active');
    });
  }, ev => {
    // mouseleave
    var
      $this = $(ev.currentTarget),
      dataType = $this.data('type');

    $this.css({display: ''});

    $('.js-dropdownMenu__item').each((idx, el) => {
      var $el = $(el);

      if ($el.data('type') !== dataType) return;

      $el.removeClass('js-active');
    });

  }); // $('.js-dropdownMenu__panel').hover()
});

